import { render, staticRenderFns } from "./c_Player_Play_Item_Ticket.vue?vue&type=template&id=8604b9e8&scoped=true&"
import script from "./c_Player_Play_Item_Ticket.vue?vue&type=script&lang=js&"
export * from "./c_Player_Play_Item_Ticket.vue?vue&type=script&lang=js&"
import style0 from "./c_Player_Play_Item_Ticket.vue?vue&type=style&index=0&id=8604b9e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8604b9e8",
  null
  
)

export default component.exports